<div class="d-flex justify-content-between align-items-center px-3 py-2 sticky-top bg-light" style="width: 100%">
  <div class="left-header d-lg-block d-none">
    <div class="row">
      <div class="btn-group btn-breadcrumb">
        <a [routerLink]="dashboardRoute" class="btn btn-default" [attr.aria-label]="'Dashboard' | translate">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M20.0402 6.81969L14.2802 2.78969C12.7102 1.68969 10.3002 1.74969 8.79023 2.91969L3.78023 6.82969C2.78023 7.60969 1.99023 9.20969 1.99023 10.4697V17.3697C1.99023 19.9197 4.06023 21.9997 6.61023 21.9997H17.3902C19.9402 21.9997 22.0102 19.9297 22.0102 17.3797V10.5997C22.0102 9.24969 21.1402 7.58969 20.0402 6.81969ZM12.7502 17.9997C12.7502 18.4097 12.4102 18.7497 12.0002 18.7497C11.5902 18.7497 11.2502 18.4097 11.2502 17.9997V14.9997C11.2502 14.5897 11.5902 14.2497 12.0002 14.2497C12.4102 14.2497 12.7502 14.5897 12.7502 14.9997V17.9997Z"
              fill="#172720" />
          </svg>
        </a>
        <span class="btn btn-default text-danger">{{ activePageLabel | translate }}</span>
      </div>
    </div>
  </div>

  <div class="header_right d-flex align-items-center ms-auto">
    @if (roleTypeId !== RoleTypeId.Admin) {
    <div>
      <app-form-offline-sync-indicator-component></app-form-offline-sync-indicator-component>
    </div>
    }
    <!-- <div class="ms-3">
      <app-language></app-language>
    </div> -->
    <div class="ms-3">
      <app-role></app-role>
    </div>
    @if (!isSuperAdmin && roleTypeId !== RoleTypeId.Admin) {
    <div class="ms-3">
      <app-notification></app-notification>
    </div>
    }
    <div class="ms-3">
      <app-user-profile></app-user-profile>
    </div>
  </div>
</div>
<div class="d-lg-none d-inline-block">
  <div class="row">
    <div class="btn-group btn-breadcrumb">
      <a [routerLink]="dashboardRoute" class="btn btn-default" [attr.aria-label]="'Dashboard' | translate">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M20.0402 6.81969L14.2802 2.78969C12.7102 1.68969 10.3002 1.74969 8.79023 2.91969L3.78023 6.82969C2.78023 7.60969 1.99023 9.20969 1.99023 10.4697V17.3697C1.99023 19.9197 4.06023 21.9997 6.61023 21.9997H17.3902C19.9402 21.9997 22.0102 19.9297 22.0102 17.3797V10.5997C22.0102 9.24969 21.1402 7.58969 20.0402 6.81969ZM12.7502 17.9997C12.7502 18.4097 12.4102 18.7497 12.0002 18.7497C11.5902 18.7497 11.2502 18.4097 11.2502 17.9997V14.9997C11.2502 14.5897 11.5902 14.2497 12.0002 14.2497C12.4102 14.2497 12.7502 14.5897 12.7502 14.9997V17.9997Z"
            fill="#172720" />
        </svg>
      </a>
      <span class="btn btn-default text-danger">{{ activePageLabel | translate }}</span>
    </div>
  </div>
</div>
